import React, { useState, useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { withRouter } from "../../../providers/withRouter";
import FiltrosComunidades from "../../../components/filtros/filtrosComunidades";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { DataTable } from "../../../components";
import { Box, Select } from "@mui/material";
import { deleteCentroTrabajo, deleteFinca, getListFincas, getListFincasToExport, /* getImpagosComunidad, */ updateInstalacion, UpdateSale } from "../../../services";
// import { FileWarning } from "lucide-react"; // IMPAGOS desactivado en test
// import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material"; // IMPAGOS desactivado en test
// import CloseIcon from "@mui/icons-material/Close"; // IMPAGOS desactivado en test
import { UsuarioContext } from "../../../providers/userContext";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import {
  useRecogerURLParamsFiltros,
  construirURLParamsFiltros,
} from "./../../../functions/parametrosURL/funcionesParamsURL";
import Delete from "../../../icons/delete.svg";
import { ventaMasReciente, GRUPOS_SERVICIO } from "../../../functions/funciones";
import Swal from "sweetalert2";
import Excel from "../../../icons/excel.svg"
import CircularProgress from '@mui/material/CircularProgress';
import { set } from "date-fns";

const GestionComunidades = () => {
  const { t } = useTranslation(['properties', 'common', 'suppliers']);
  const user = useContext(UsuarioContext);
  const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [loading, setLoading] = useState(true);
  const [loadingXls, setLoadingXls] = useState(false);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [estados, setEstados] = useState([]);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });
  const [clean, setClean] = useState(false);
  const [primeraCarga, setPrimeraCarga] = useState(true);

  // IMPAGOS desactivado en test
  // const [impagoModal, setImpagoModal] = useState({ open: false, nif: null, razonSocial: "", loading: false, facturas: [] });

  // const abrirModalImpago = async (row) => {
  //   setImpagoModal({ open: true, nif: row.nif, razonSocial: row.razonSocial, loading: true, facturas: [] });
  //   try {
  //     const res = await getImpagosComunidad(row.nif);
  //     setImpagoModal((prev) => ({ ...prev, loading: false, facturas: res?.facturas || [] }));
  //   } catch (e) {
  //     setImpagoModal((prev) => ({ ...prev, loading: false, facturas: [] }));
  //     toast.error(t('management.impagoError', { defaultValue: 'No se pudieron cargar las facturas impagadas' }));
  //   }
  // };

  // const cerrarModalImpago = () => setImpagoModal({ open: false, nif: null, razonSocial: "", loading: false, facturas: [] });

  const refControladorAborto = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();
  let params = new URLSearchParams(location.search);
  const pagina = parseInt(params.get("pagina")) || 1;
  const limiteParam = parseInt(params.get("limite")) || 50;

  const clearFilters = () => {
    if (
      user.rol === "CONSUL" &&
      localStorage.getItem("hasReloaded") === "true"
    ) {
      setBusqueda({
        consul_id: user.id,
      });
    } else if (user.rol === "CONSUL") {
      setBusqueda({
        consul_id: user.id,
      });
    } else {
      setBusqueda({});
    }

    setClearFilterActivo(true);
  };

  const fetchData = async ({
    offset,
    limit,
    filtros = busqueda,
    order,
    orderBy,
  } = {}) => {

    if (refControladorAborto.current) {
      refControladorAborto.current.abort();
    }
    const nuevoControladorAborto = new AbortController();
    refControladorAborto.current = nuevoControladorAborto;

    orderBy = orderBy || filtroOrder.ordenadoPor || "id";
    order = order || filtroOrder.orden || "ASC";

    if (primeraCarga) {
      if (filtros.consul_id === undefined && user.rol === "CONSUL") {
        filtros.consul_id = user.id;
      } else if (filtros.consul_id === "0") {
        delete filtros.consul_id;
      }
      setPrimeraCarga(false);
    }

    construirURLParamsFiltros(
      navigate,
      offset || 1,
      limit || 50,
      filtros,
      order,
      orderBy
    );

    const payload = {
      filtros,
      params: { page: offset, limit: limit, order, orderBy },
      signal: nuevoControladorAborto.signal,
    };

    try {
      setLoading(true);
      // Obtener estados del cache (localStorage)
      const estadosCache = JSON.parse(localStorage.getItem("states")) || [];
      setEstados(estadosCache);

      const response = await getListFincas(payload);
      const { meta, data } = response;
      setData({
        meta,
        rows: formatData(data, meta),
      });


    } catch (error) {
      if (error.name === "CanceledError" || error.name === "AbortError") {
        return;
      }
      console.log(error);
    } finally {
      if (refControladorAborto.current === nuevoControladorAborto) {
        setLoading(false);
      }
    }
  };

  const formatData = (data, meta) => {
    const formattedData = [];
    data.map((row, i) => {
      // const diferenciaMeses = diferenciaMesesCaducidad(row.fechaRenovacion, row.createdAt)
      const sale_cae = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cae);
      const sale_lopd = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.lopd);
      const sale_cai = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cai);
      const instalacion_kae = row?.instalacionesKae?.find(i => i.prop_id === row.id) || null;
      formattedData.push({
        i: (meta.current_page - 1) * meta.per_page + (i + 1),
        aaff_nif: row?.aaff?.nif,
        razonSocial: row.razonSocial,
        nif: row.nif,
        direccion: row.direccion,
        codigoPostal: row.codigoPostal,
        municipio: row.municipio,
        provincia: row.provincia,
        proveedores: row.sale_cae && row.proveedores !== 0 && row.proveedores !== false ? row.num_suppliers : t('management.noHasSuppliers'),
        isWorkcenter: false,
        activo: row.activo === null ? true : row.activo,
        estado: row.estado_id === null ? 1 : row.estado_id,
        // caducada: diferenciaMeses > 13 ? true : false
        saleCae_id: row.sale_cae, //sale_cae?.id || null,
        saleLopd_id: row.sale_lopd,
        saleCai_id: row.sale_cai,
        instalacionKae_id: row.instalacion_kae,
        estadoCae: row.estado_cae
          ? row.estado_cae === null
            ? 1
            : row.estado_cae
          : "-",
        estadoLopd: row.estado_lopd
          ? row.estado_lopd === null
            ? 1
            : row.estado_lopd
          : "-",
        estadoCai: row.estado_cai
          ? row.estado_cai === null
            ? 1
            : row.estado_cai
          : "-",
        estadoKae: row.estado_kae ? row.estado_kae : "-",
        // impagada: row.impagada === true || row.impagada === 1, // IMPAGOS desactivado en test
      });
      if (row.workcenters?.length > 0) {
        row.workcenters?.forEach((wc) => {
          formattedData.push({
            i: "",
            id: wc.id,
            aaff_nif: row?.aaff?.nif,   //nif de la AAFF
            razonSocial: wc.razonSocial,   //nombre del centro de trabajo
            nif: row.nif,   //nif de la comunidad
            codigoPostal: "",
            municipio: "",
            provincia: "",
            proveedores: "",
            isWorkcenter: true,
            activo: "",
            estadoCae: "",
            estadoLopd: "",
            estadoCai: "",
            estadoKae: "",
            saleCae_id: "",
            saleLopd_id: "",
            saleCai_id: "",
            instalacionKae_id: "",
          });
        });
      }
    });
    return formattedData;
  };
  const exportData = async () => {
    const toastId = toast.loading(t('management.generatingExcel'));
    setLoadingXls(true);
    try {
      const data = await getListFincasToExport({ filtros: busqueda });

      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `comunidades_${Date.now()}.xlsx`);

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
      toast.update(toastId, {
        render: t('management.excelSuccess'),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setLoadingXls(false);
    } catch (error) {
      console.error("Error al descargar el Excel:", error);
      toast.update(toastId, {
        render: t('management.excelError'),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      setLoadingXls(false);
    }
  };
  // const onClick = (nif) => {
  //   const actualizarEstado = data.rows.map((row) => {

  //     if (row.nif === nif) {
  //       cambiarFinca(nif, {
  //         activo: !row.activo
  //       })
  //       return { ...row, activo: !row.activo };

  //     }
  //     return row;
  //   });
  //   setData({ ...data, rows: actualizarEstado });
  // };

  const handleChangeEstado = (evt, id, serv) => {
    // console.log(evt.target.value, id, serv);
    const valor = parseInt(evt.target.value);
    // console.log(valor);

    const claves = {
      cae:  { idKey: 'saleCae_id',         estado: 'estadoCae',  update: UpdateSale },
      lopd: { idKey: 'saleLopd_id',        estado: 'estadoLopd', update: UpdateSale },
      cai:  { idKey: 'saleCai_id',         estado: 'estadoCai',  update: UpdateSale },
      kae:  { idKey: 'instalacionKae_id',  estado: 'estadoKae',  update: updateInstalacion },
    };
    const config = claves[serv];
    if (!config) return;
    const actualizarEstado = data.rows.map((row) => {
      const registro_id = row[config.idKey];
      if (registro_id === id) {
        config.update(id, { estado_id: valor });
        return { ...row, [config.estado]: valor };
      }
      return row;
    });
    // console.log(actualizarEstado);
    setData({ ...data, rows: actualizarEstado });
  };

  const ComunidadesRows = [
    {
      id: "i",
      numeric: true,
      disablePadding: false,
      label: "",
    },
    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('columns.community'),
      overrideFunc: (data, row) => (
        // console.log("aaaaaaaaa", row)
        row.isWorkcenter === false ?
          <Link to={`/aaff/${row.aaff_nif}/comunidades/${row.nif}`}>{data}</Link>
          :
          // <Link to={`/aaff/${row.aaff_nif}/comunidades/${row.nif}`}>{data}</Link>
          <Typography style={{ textAlign: 'left' }}>
            {data}
          </Typography>
      ),
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('columns.nif'),
      overrideFunc: (data, row) => (
        row.isWorkcenter === false ?
          <Link to={`/aaff/${row.aaff_nif}/comunidades/${row.nif}`}>{data}</Link>
          :
          ""
      ),
    },
    {
      id: "direccion",
      numeric: false,
      disablePadding: false,
      label: t('columns.address'),
    },
    {
      id: "codigoPostal",
      numeric: false,
      disablePadding: false,
      label: t('fields.postalCode').toUpperCase(),
    },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('columns.municipality'),
    },
    {
      id: "provincia",
      numeric: false,
      disablePadding: false,
      label: t('common:form.province').toUpperCase(),
    },
    ...(user.rol !== "ADMIN_CAI" ? [
    {
      id: "proveedores",
      numeric: false,
      disablePadding: false,
      label: t('suppliers:title').toUpperCase(),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <Link to={`/aaff/${row.aaff_nif}/comunidades/${row.nif}/proveedores`}>
          {data}
        </Link>
      ),
    },
    {
      id: "estadoCae",
      numeric: false,
      disablePadding: false,
      label: t('columns.caeStatus'),
      overrideFunc: (data, row) =>
        !row.isWorkcenter ? (
          data !== "-" ? (
            <div className="activoSelect">
              <Select
                label={t('edit.fields.caeStatus')}
                native
                name="estadoCae"
                id="estadoCae"
                style={{
                  textTransform: "uppercase",
                  padding: 0,
                  fontSize: "11px",
                  color:
                    data === 1 || null
                      ? "#3eae3e"
                      : data === 2 || data === 3
                        ? "#FF8300"
                        : data === 4 || data === 5
                          ? "#EE4534"
                          : "#000",
                }}
                onChange={(event) =>
                  handleChangeEstado(event, row.saleCae_id, "cae")
                }
                defaultValue={data}
              >
                {estados?.map((e, i) => {
                  return (
                    <option
                      key={i}
                      value={e.id}
                      style={{
                        color:
                          e.id === 1 || e.id == null
                            ? "#3eae3e"
                            : e.id === 2 || e.id === 3
                              ? "#FF8300"
                              : e.id === 4 || e.id === 5
                                ? "#EE4534"
                                : "#000",
                      }}
                    >
                      {t(`common:stateNames.${e.nombre}`, e.nombre)}
                    </option>
                  );
                })}
              </Select>
            </div>
          ) : (
            data
          )
        ) : (
          ""
        ),
    },
    {
      id: "estadoLopd",
      numeric: false,
      disablePadding: false,
      label: t('columns.lopdStatus'),
      overrideFunc: (data, row) =>
        !row.isWorkcenter ? (
          data !== "-" ? (
            <div className="activoSelect">
              <Select
                label={t('edit.fields.lopdStatus')}
                native
                name="estadoLopd"
                id="estadoLopd"
                style={{
                  textTransform: "uppercase",
                  padding: 0,
                  fontSize: "11px",
                  color:
                    data === 1 || null
                      ? "#3eae3e"
                      : data === 2 || data === 3
                        ? "#FF8300"
                        : data === 4 || data === 5
                          ? "#EE4534"
                          : "#000",
                }}
                onChange={(event) =>
                  handleChangeEstado(event, row.saleLopd_id, "lopd")
                }
                defaultValue={data}
              >
                {estados?.map((e, i) => {
                  return (
                    <option
                      key={i}
                      value={e.id}
                      style={{
                        color:
                          e.id === 1 || e.id == null
                            ? "#3eae3e"
                            : e.id === 2 || e.id === 3
                              ? "#FF8300"
                              : e.id === 4 || e.id === 5
                                ? "#EE4534"
                                : "#000",
                      }}
                    >
                      {t(`common:stateNames.${e.nombre}`, e.nombre)}
                    </option>
                  );
                })}
              </Select>
            </div>
          ) : (
            data
          )
        ) : (
          ""
        ),
    }] : []),
    ...(user.rol !== "ADMIN_CAI" ? [
    {
      id: "estadoCai",
      numeric: false,
      disablePadding: false,
      label: t('columns.caiStatus'),
      overrideFunc: (data, row) =>
        !row.isWorkcenter ? (
          data !== "-" ? (
            <div className="activoSelect">
              <Select
                label={t('edit.fields.caiStatus')}
                native
                name="estadoCai"
                id="estadoCai"
                style={{
                  textTransform: "uppercase",
                  padding: 0,
                  fontSize: "11px",
                  color:
                    data === 1 || null
                      ? "#3eae3e"
                      : data === 2 || data === 3
                        ? "#FF8300"
                        : data === 4 || data === 5
                          ? "#EE4534"
                          : "#000",
                }}
                onChange={(event) =>
                  handleChangeEstado(event, row.saleCai_id, "cai")
                }
                defaultValue={data}
              >
                {estados
                  ?.filter((e) => ["Activa", "Baja", "Anulado"].includes(e.nombre))
                  .map((e, i) => {
                  return (
                    <option
                      key={i}
                      value={e.id}
                      style={{
                        color:
                          e.id === 1 || e.id == null
                            ? "#3eae3e"
                            : e.id === 2 || e.id === 3
                              ? "#FF8300"
                              : e.id === 4 || e.id === 5
                                ? "#EE4534"
                                : "#000",
                      }}
                    >
                      {t(`common:stateNames.${e.nombre}`, e.nombre)}
                    </option>
                  );
                })}
              </Select>
            </div>
          ) : (
            data
          )
        ) : (
          ""
        ),
    }]:[
      {
        id: "estadoCai",
        numeric: false,
        disablePadding: false,
        label: t('columns.caiStatus'),
        noObjeto:true,
        overrideFunc: (data, row) => {
          if (row.isWorkcenter || data === "-") return "";
          const estado = estados?.find((e) => e.id === Number(data));
          return estado ? (
            <span style={{ fontSize: '11px', color: estado.id === 1 || estado.id == null ? "#3eae3e" : estado.id === 2 || estado.id === 3 ? '#FF8300' : estado.id === 4 || estado.id === 5 ? "#EE4534" : "#000" }}>
              {t(`common:stateNames.${estado.nombre}`, estado.nombre)}
            </span>
          ) : data;
        },
      }
    ]),
    ...(user.rol !== "ADMIN_CAI" ? [
    {
      id: "estadoKae",
      numeric: false,
      disablePadding: false,
      label: t('columns.kaeStatus'),
      overrideFunc: (data, row) =>
        !row.isWorkcenter ? (
          data !== "-" ? (
            <div className="activoSelect">
              <Select
                label={t('edit.fields.kaeStatus')}
                native
                name="estadoKae"
                id="estadoKae"
                style={{
                  textTransform: "uppercase",
                  padding: 0,
                  fontSize: "11px",
                  color:
                    data === 1 || null
                      ? "#3eae3e"
                      : data === 2 || data === 3
                        ? "#FF8300"
                        : data === 4 || data === 5
                          ? "#EE4534"
                          : "#000",
                }}
                onChange={(event) =>
                  handleChangeEstado(event, row.instalacionKae_id, 'kae')
                }
                defaultValue={data}
              >
                {estados
                  ?.filter((e) => ["Activa", "Baja", "Anulado"].includes(e.nombre))
                  .map((e, i) => {
                  return (
                    <option
                      key={i}
                      value={e.id}
                      style={{
                        color:
                          e.id === 1 || e.id == null
                            ? "#3eae3e"
                            : e.id === 2 || e.id === 3
                              ? "#FF8300"
                              : e.id === 4 || e.id === 5
                                ? "#EE4534"
                                : "#000",
                      }}
                    >
                      {t(`common:stateNames.${e.nombre}`, e.nombre)}
                    </option>
                  );
                })}
              </Select>
            </div>
          ) : (
            data
          )
        ) : (
          ""
        ),
    },
    // IMPAGOS desactivado en test
    // {
    //   id: "impago",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "",
    //   noObjeto: true,
    //   overrideFunc: (data, row) =>
    //     !row.isWorkcenter && row.impagada ? (
    //       <FileWarning
    //         size={18}
    //         color="#EE4534"
    //         style={{ cursor: "pointer" }}
    //         title={t('management.viewImpago', { defaultValue: 'Ver facturas impagadas' })}
    //         onClick={() => abrirModalImpago(row)}
    //       />
    //     ) : (
    //       ""
    //     ),
    // },
    {
      id: "baja",
      numeric: false,
      disablePadding: false,
      label: t('columns.deactivate'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        // console.log(row),

        row.isWorkcenter ? (
          <img
            src={Delete}
            alt={t('columns.deactivate')}
            className="tableIcon"
            style={{ margin: 0 }}
            onClick={() => eliminarCentroTrabajo(row)}
          ></img>
        ) : (
          <img
            src={Delete}
            alt={t('columns.deactivate')}
            className="tableIcon"
            style={{ margin: 0 }}
            onClick={() => bajaFinca(row)}
          ></img>
        )
      )

    }]: []),
    // {
    //   id: "activo",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "ACTIVO",
    //   noObjeto:true,
    //   overrideFunc: (data, row) => (
    //     data !== "" ?
    //       <div className="activoSelect">
    //         <Select
    //             label="Activo"
    //             native
    //             name="activo"
    //             id="activo"
    //             style={{ textTransform: 'uppercase', padding: 0, fontSize: '11px', color: data ? "green" : 'red' }}
    //             onChange={() => onClick(row.nif)} value={data}
    //           >
    //             <option value={true}>Sí</option>
    //             <option value={false}>No</option>
    //           </Select>
    //       </div>
    //     : ""
    //   )
    // }
  ];

  function bajaFinca(f) {
    Swal.fire({
      title: t('confirmations.deactivateProperty', { name: f.razonSocial }),
      showCancelButton: true,
      confirmButtonText: t('confirmations.deactivate'),
      confirmButtonColor: '#92004D',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        deleteFinca(f.nif)
          .then((res) => {
            if (res.message === "PROPERTIE_DELETED") {
              toast.success(t('confirmations.deactivatedSuccess'));
              fetchData({
                offset: pagina,
                limit: limiteParam,
                order: filtroOrder.orden || "ASC",
                orderBy: filtroOrder.ordenadoPor || "id",
                filtros: busqueda,
              });
              // setClean(!clean);
            } else {
              toast.error(t('confirmations.deactivateError'));
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(t('confirmations.deactivateError'));
          });
      }
    });
  }

  function eliminarCentroTrabajo(f) {
    // console.log(f);
    Swal.fire({
      title: t('confirmations.deactivateProperty', { name: f.razonSocial }),
      showCancelButton: true,
      confirmButtonText: t('confirmations.deactivate'),
      confirmButtonColor: '#92004D',
    }).then((result) => {
      if (result.isConfirmed) {
        deleteCentroTrabajo(f.id)
          .then((res) => {
            toast.success(t('confirmations.workCenterDeleted'));
            fetchData({
              offset: pagina,
              limit: limiteParam,
              order: filtroOrder.orden || "ASC",
              orderBy: filtroOrder.ordenadoPor || "id",
              filtros: busqueda,
            });
            // setClean(!clean);
          })
          .catch((error) => {
            console.log(error);
            toast.error(t('confirmations.workCenterDeleteError'));
          });
      }
    });
  }
  const filtrarDatos = (filtros) => {
    setBusqueda(filtros);
    setBusquedaActiva(true);
  };

  useEffect(() => {
    return () => {
      if (refControladorAborto.current) {
        refControladorAborto.current.abort();
      }
    };
  }, []);

  return (
    <>
      <BreadCrumb
        rutas={[{ path: "/comunidades", label: t('management.title') }]}
        style={{ margin: "0 10px" }}
      />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">{t('management.header')}</div>
        </div>
      </div>
      <div className="pageContent tableContainer">
        <FiltrosComunidades
          onFilter={filtrarDatos}
          clearFilter={clearFilters}
          filtrosIniciales={busqueda}
          clean={clean}
        />
        {user.rol !== "ADMIN_CAI" && (
          <div style={{ margin: '20 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <button
              className="bigBtn"
              onClick={exportData}
              disabled={loading} // Es buena práctica deshabilitar el botón mientras carga
            >
              {!loadingXls ? (
                <>
                  <img src={Excel} alt={t('management.generateList')} width="30px" style={{ marginRight: '10px' }} />
                  <span>{t('management.generateList')}</span>
                </>
              ) : (
                <>
                  <CircularProgress
                    style={{ color: '#fff', width: '16px', height: '16px', marginRight: '10px' }}
                  />
                  <span>{t('management.generatingList')}</span>
                </>
              )
              }
            </button>
          </div>
        )}
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={ComunidadesRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('noCommunities')}
                propCaducada={true}
              />
            </Box>
          </Box>
        </div>
      </div>
      <style jsx="true">{`
        #trabajadores,
        #activo,
        #estadoCae,
        #estadoLopd,
        #estadoCai,
        #estadoKae {
          padding: 0 25px 0 0;
          border: none;
        }
        #estadoCai, #estadoKae{
          width: auto !important;
        }
        .activoSelect fieldset,
        .activoSelect select:hover {
          border-color: rgba(0, 0, 0, 0) !important;
        }
      `}</style>

      {/* IMPAGOS desactivado en test
      <Dialog open={impagoModal.open} onClose={cerrarModalImpago} maxWidth="md" fullWidth>
        <DialogTitle sx={{ pr: 6 }}>
          {t('management.impagoModalTitle', { defaultValue: 'Facturas impagadas' })}
          {impagoModal.razonSocial ? ` · ${impagoModal.razonSocial}` : ""}
          <IconButton
            onClick={cerrarModalImpago}
            sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {impagoModal.loading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "30px 0" }}>
              <CircularProgress style={{ color: "#92004D" }} />
            </div>
          ) : impagoModal.facturas.length === 0 ? (
            <p style={{ textAlign: "center", color: "#6b7280", padding: "20px 0" }}>
              {t('management.impagoNoData', { defaultValue: 'No hay datos de facturas para esta comunidad.' })}
            </p>
          ) : (
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
              <thead>
                <tr style={{ textAlign: "left", borderBottom: "2px solid #e5e7eb" }}>
                  <th style={{ padding: "8px" }}>{t('management.impagoSerie', { defaultValue: 'Serie factura' })}</th>
                  <th style={{ padding: "8px" }}>{t('management.impagoFecha', { defaultValue: 'Fecha factura' })}</th>
                  <th style={{ padding: "8px" }}>{t('management.impagoConcepto', { defaultValue: 'Concepto' })}</th>
                  <th style={{ padding: "8px" }}>{t('management.impagoEstado', { defaultValue: 'Estado' })}</th>
                </tr>
              </thead>
              <tbody>
                {impagoModal.facturas.map((f, idx) => (
                  <tr key={idx} style={{ borderBottom: "1px solid #f1f1f1" }}>
                    <td style={{ padding: "8px" }}>{f.serieFactura || "-"}</td>
                    <td style={{ padding: "8px" }}>
                      {f.fechaFactura ? f.fechaFactura.split("-").reverse().join("/") : "-"}
                    </td>
                    <td style={{ padding: "8px" }}>{f.concepto || "-"}</td>
                    <td style={{ padding: "8px" }}>{f.estado || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </DialogContent>
      </Dialog>
      */}
    </>
  );
};

export default withRouter(GestionComunidades);
